import { SortDefault, SortAscending, SortDescending } from "@/assets/icons";
import DataTable from "./DataTable";

const SortIcon = ({ sort = "", onChange }: { sort: string; onChange: (val: string) => void }) => {
  const handleClick = () => {
    const newSort = sort === "desc" ? "asc" : "desc";
    onChange(newSort);
  };

  return (
    <div className="cursor-pointer" onClick={handleClick}>
      {sort === "" && <SortDefault />}
      {sort === "asc" && <SortAscending />}
      {sort === "desc" && <SortDescending />}
    </div>
  );
};


export { SortIcon, DataTable };
